import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Slider from "@material-ui/core/Slider";
import VolumeDown from "@material-ui/icons/VolumeDown";
import VolumeUp from "@material-ui/icons/VolumeUp";
import { TextField } from "@material-ui/core";
import { P1, P2, P3 } from 'assets/fonts';

const useStyles = makeStyles({
  root: {
    width: "100%",
    textAlign: "center",
    position: "relative"
  },
});

export default function ContinuousSlider(props) {
  const classes = useStyles();
  const [value, setValue] = React.useState(null);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    props.handleVolume(newValue);
  };

  return (
    <div className={classes.root}>
      <Grid container spacing={2}>
        <Grid item>
          <VolumeDown />
        </Grid>
        <Grid item xs>
          <Slider
            value={value ?? 50}
            onChange={handleChange}
            aria-labelledby="continuous-slider"
          />
        </Grid>
        <Grid item>
          <VolumeUp />
        </Grid>
        <Grid item>
          <P3 style={{ fontWeight: "300" }}>{value ?? <P3 style={{ color: "#FF6666" }}>* required</P3>}</P3>
        </Grid>
      </Grid>
    </div>
  );
}
